import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

// PrivacyStatement component
// Usage: import PrivacyStatement from './PrivacyStatement';
// Add a route: <Route path="/privacy_statement" element={<PrivacyStatement />} />

export default function PrivacyStatement() {
  const { t } = useTranslation();
  const sections = [
    {
      title: t("1. 信息的收集"),
      content: [
        t("在易皓网站上，您可订购服务、登记索取材料或加入社区参与我们的活动。在这些网页上，您需要提供的个人信息有：姓名、电子邮件地址、电话号码、地址、企业类型、客户喜好信息，以及注册或申请服务时需要的其它相关个人信息。以此为基础，我们为您提供更好的网站在线服务、协助您解决技术问题、访问后提供跟踪服务等，您完全可以自行选择加入与否。"),
        t("我们将不断改进我们的产品和服务（包括注册登记），以创建和提供更能满足您需求的内容，我们可能还会要求您提供有关您个人或职业兴趣、人口统计、接受易皓服务的经历以及您喜爱的联系方式等信息。")
      ]
    },
    {
      title: t("2. 信息的使用"),
      content: [
        t("您提供的信息将受到严格保密，易皓使用您的这些信息只是为了更好地了解您的需要，帮助您完成购买交易、日后联络、提供有益的更新服务，并且为您提供更能满足您个人需要的网站。"),
        t("为了更好地回应您的服务需求，易皓可能会将您所提供信息提交给易皓下属的销售、代理或专业咨询及技术支持人员。易皓可能会询问您是否愿意将相关信息透露给易皓所挑选的合作伙伴，以便与后者共同为您提供优质服务。在特定情况下，易皓可能以所掌握的信息与您联系，进行市场调查或为您提供您可能感兴趣的市场信息。")
      ]
    },
    {
      title: t("3. 信息保护"),
      content: [
        t("当您通过注册或其它方式向我们提供个人信息时，易皓不会把您的个人识别信息出售或出租给第三方。一旦易皓的代理商或承包商获准使用您的个人信息与调查信息，则必须对此类信息加以严格保密，且不得将其用于除履行易皓所授权服务之外的其它用途。易皓将不会在未经您事先知晓和许可的情况下，以与上述内容无关的方式随意使用或分享您在线提供给我们的个人识别信息。您的许可总被首先保障，我们决不会与任何不代表易皓及不受我们保密政策约束的第三方分享您的信息。"),
        t("易皓可能会将在网站上收集到的信息与来自第三方的数据进行整理或合并，以便于向您推广优质产品或服务。")
      ]
    },
    {
      title: t("4. 信息访问控制"),
      content: [
        t("为了保护您的隐私和安全，易皓将采取合理的措施在注册时验证身份，通过后您才能访问或修改信息。易皓公司力求使您的个人识别信息保持准确，并使您能够方便地在线访问个人信息及注册数据，使您可随时更新或修改您的信息。"),
        t("请注意，本网站到第三方网站的链接仅为便利而为之，如果使用这些链接，您将离开易皓网站。而它们可能会收集与您有关的个人身份识别信息。因此，易皓对这些网站及其任何信息、软件或其他产品、材料、或因使用它们而可能获得的任何结果不予认可，也不作任何陈述。链接至易皓的第三方网站的信息惯例并不在此隐私声明范围之内。")
      ]
    },
    {
      title: t("5. 外包、研发支持及咨询服务所涉信息保护"),
      content: [
        t("易皓对于基于网络方式提供的外包、研发支持以及其他咨询服务中可能接触到的相关信息特别做出以下陈述：易皓所提供以上服务时，可能间接接触到由易皓的直接客户所提供的其下属客户、雇员、合作伙伴或关联人员的相关信息。在该等情形下，易皓对上述信息并不具有控制力。易皓仅为履行其服务义务而对其加以审慎使用与控制。易皓对任何该类信息本身搜集、使用和传送可能存在的权利瑕疵不负任何责任。同时，对于以上信息所有人未能采取妥善措施（包括且不限于提前通知或提出许可要求等方式）在上述信息传送至易皓之前加以阻止由此产生的任何损害，易皓亦不负有任何责任。"),
      ]
    },
    {
      title: t("6. 数据的安全性"),
      content: [
        t("我们将保证您个人可以识别信息的质量和完整。我们会认真保护您的资料以防止未经授权的访问，信息丢失、泄露、误用、篡改、或是毁坏。在本公司内，数据存放在有密码控制的服务器中，访问受到严格限制。我们将竭诚努力，及时应您的要求对您的个人信息误差进行纠正。为了对您的个人信息误差进行纠正，请您说明相关纠错信息并附上要求更正的细节。"),
      ]
    },
    {
      title: t("7. 关于年幼用户的特别说明"),
      content: [
        t("易皓最大限度地注意未满16岁的用户的安全。对于未满16岁的用户，请在监护人同意下提供个人信息当你注册你的姓名，地址，电话或其他个人资料时，当你从网上购物时，一定要确保你的父母或监护人在计算机旁和你一起进行。")
      ]
    },
    {
      title: t("8. 关于cookie技术的使用"),
      content: [
        t("我们会使用cookies的技术来分析网页的使用情形，并保存您通过网络接受易皓服务及产品提供的历史记录。Cookie 是放置在您的电脑硬盘中的一段要求权限的文字。使用此项技术并不表示我们可自动获悉有关您的任何信息。我们可以确定您使用的计算机类型，但使用 cookies 的主要目的还在于使您在访问易皓网站时获得更佳的体验。易皓绝对无意在您使用易皓网站时侵犯您的隐私。"),
        t("您还拥有完全的自主权，可选择将网络浏览器（Microsoft Internet Explorer 或 Netscape Navigator）设置为提前通知您 cookie 的放置请求或完全拒绝 cookie。")
      ]
    },
    {
      title: t("9. 关于本声明的更新"),
      content: [
        t(`本声明及对本网站使用方法的解释权归于易皓，易皓将可能更新本隐私保护声明。更新后，我们还会修改隐私权声明底部的(最近更新)的日期。如本声明有实质性的更改，易皓将在Web站点上放置醒目的提示以通告用户。`)
      ]
    },
    {
      title: t("10. 相关争议的法律适用"),
      content: [
        t("因本声明或使用本网站所发生的争议适用中华人民共和国法律。")
      ]
    },
    {
      title: t("11. 第三方SDK收集使用信息说明"),
      content: [
        t("为保障App的稳定运行或实现相关功能，我们可能会接入由第三方提供的软件开发包(SDK)实现前述目的。我们会尽到审慎义务，对合作方获取信息的SDK进行严格的安全监测，以保护数据安全。"),
        t("我们接入的第三方SDK主要服务于您以及其他的用户的需求，因此在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK。我们会及时在本说明中向您公开说明接入第三方SDK的最新情况。目前App接入的第三方SDK列明如下:"),
      ]
    },
    {
      title: t("SDK 名称：APP支付客户端SDK"),
      content: [
        t("开发者：支付宝(杭州)信息技术有限公司"),
        t("SDK 功能：提供 App 内支付功能"),
        t("SDK 收集的信息类型：设备信息、操作日志、位置信息、账户信息"),
        t("SDK 收集信息的用途：提供 App 内支付功能"),
        {
          label: t("SDK 隐私政策链接："),
          url: "https://opendocs.alipay.com/open/54/01g6qm#支付宝%20App%20支付客户端%20SDK%20隐私政策"
        }
      ]
    },
    {
      title: t("SDK 名称：微信OpenSDK Android"),
      content: [
        t("开发者：深圳市腾讯计算机系统有限公司"),
        t("SDK 功能：提供 App 内支付功能"),
        t("SDK 收集的信息类型：设备信息、操作日志、位置信息、账户信息"),
        t("SDK 收集信息的用途：提供 App 内支付功能"),
        {
          label: t("SDK 隐私政策链接："),
          url: "https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
        }
      ]
    },
    {
      title: t("12. 注销账户"),
      content: [
        t("自助注销账户路径，用户可以在“我的-设置-注销账号”路径下找到并使用该功能。"),
       t("注销申请后会立即退出APP，并且在后台在7天后进行账号注销处理，注销完成后用户的个人信息将被删除，无法恢复，请谨慎操作。"),
        t("若用户在7天内再次登录，则注销申请将被取消，账号将继续保留。"),
      ]
    },
    {
      title: t("13. 应用权限"),
      content: [
        t("“为了您提供更好的服务，本应用将获取以下权限："),
        t("相机权限： 仅在您更新头像或扫码登录时，用于读取拍摄的照片或进行扫描。"),
        t("存储权限： 仅在您选择上传本地图片或保存截图至手机时，用于读取/写入存储空间。”"),
      ]
    },
        {
      title: t("14. 联系我们"),
      content: [
        t("如果您对本隐私政策有任何意见或问题，或者您对我们收集、使用或披露您的个人信息有任何问题，请通过下方式联系我们，并提及“隐私政策”。"),
        t("联系地址：上海市奉贤区南行港路2900号二层"),
        t("邮箱：support@esiproonline.com"),
      ]
    }
  ];

  return (
    <main className="min-h-screen bg-gray-50 py-10 leading-relaxed">
      <div className="mx-auto max-w-4xl rounded-lg bg-white p-8 shadow">
        <header className="mb-6">
          <h1 className="esi-content-title">{t(`Shanghai Yihao Culture Communication Co., Ltd. Service Agreement and Privacy Policy`)}</h1>
        </header>

        <section className="space-y-4 prose">
          <p className='esi-content-paragraph text-[16px]'>
            {t("Last updated")}：{t("February 19, 2026")} <br />
            {t("上海易皓文化传播有限公司（以下简称“易皓”）承诺尊重和保护用户的隐私，并将此作为公司事业的基础及担负的社会责任。")}
          </p>
          <p className='esi-content-paragraph text-[16px]'>
          </p>

          {sections.map((section, index) => (
            <div key={index}>
              <h2 className='esi-content-title text-[16px]'>{section.title}</h2>
              {section.content.map((item, idx) => {
                if (typeof item === "string") {
                  return (
                    <p className='esi-content-paragraph text-[16px]' key={idx}>{item}</p>
                  )
                }

                return (
                  <div key={idx} className='flex'>
                    <p className='esi-content-paragraph text-[16px]'>
                      {item.label}
                    </p>

                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="esi-content-paragraph text-[16px] text-blue-600 gap-1 flex"
                    >
                      <span className='underline esi-content-paragraph'>LINK</span>
                      🔗
                    </a>
                  </div>
                );
              })}
            </div>
          ))}

          {/* <footer className="mt-6 border-t pt-4 text-sm text-gray-600">
            如您对本隐私声明有任何疑问，欢迎随时联系易皓。
          </footer> */}
        </section>
      </div>
    </main>
  );
}